import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { DocumentDetail } from '@/components/DocumentDetail/DocumentDetail'
import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'

export default function InvoiceDetailPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'invoice',
  })

  const { data: documentData, isLoading: invoicesLoading } = useSWR(
    id && `/api/v2/invoices/${id}`,
    apiFetcher,
  )
  const title = `${t('detail.title')} ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/invoices',
        children: t('list.title'),
      },
      {
        href: `/invoice/${id}`,
        children: id as string,
      },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {invoicesLoading && <Loading />}

      {documentData && <DocumentDetail document={documentData} linkSegment="invoice" />}
    </>
  )
}
